export default function ($scope, $state, $location, $timeout, loginService, utils) {
  let vm;

  const KEY_EVENT_ENTER = 13;

  class RestorePasswordCtrl {
    constructor () {
      vm = this;
    }

    $onInit () {
      _.set($state, 'current.data.specialClass', 'blank');
      $timeout(() => {
        jQuery('#restore-form').on('keydown keypress', (event) => {
          if (event.which === KEY_EVENT_ENTER) {
            vm.send();
            event.preventDefault();
          }
        });
        jQuery('#restore-email').focus();
      });
    }

    send () {
      if (vm.restoreForm.$invalid) {
        jQuery('#restore-form')[0].reportValidity();
        utils.setFormFieldsDirty(vm.restoreForm);
        return;
      }

      vm.error = false;
      vm.sendProgress = true;
      loginService.restorePassword(vm.email, vm.password)
        .then((res) => {
          if (!res) {
            return Promise.reject(new Error(''));
          }
          vm.successMessage = true;
          return res;
        })
        .catch((error) => {
          if (_.get(error, 'data.data') === 'Error: Email address not found') {
            vm.errorMessage = 'דוא"ל לא רשום במערכת';
          } else {
            vm.errorMessage = 'שגיאה';
          }
          utils.notify(vm.errorMessage, 'alert-danger');
          vm.sendProgress = false;
          vm.error = true;

          return error;
        })
        .finally(() => {
          vm.sendProgress = false;
        });
    }
  }

  return new RestorePasswordCtrl();
}
